const columns = [
  {
    title: '榜单导航',
    links: [
      { label: '热门视频榜单', href: '#ranking' },
      { label: '站内爆款内容', href: '#viral' },
      { label: '口碑经典节目', href: '#classic' },
      { label: '编辑精选片单', href: '#picks' },
    ],
  },
  {
    title: '内容分区',
    links: [
      { label: '美食', href: '#ranking' },
      { label: '纪录片', href: '#ranking' },
      { label: '生活', href: '#ranking' },
      { label: '三农', href: '#ranking' },
      { label: '影视解说', href: '#ranking' },
      { label: '旅行与知识', href: '#ranking' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { label: '数据洞察说明', href: '#insights' },
      { label: '追热门上手指南', href: '#guide' },
      { label: '常见问题', href: '#faq' },
      { label: '返回页面顶部', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-accent-950 px-4 pt-12 text-accent-50 md:px-8 md:pt-16">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-1 gap-8 pb-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg tracking-wide">西瓜视频榜单</span>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-accent-100/80 md:text-sm">
              聚合西瓜视频当前高热度的视频内容与榜单数据，覆盖站内爆款、口碑节目与编辑精选，帮你省下反复刷找的时间。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">榜单速览</span>
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">精选推荐</span>
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">数据洞察</span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-accent-50">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-accent-100/80 transition-colors hover:text-accent-50 md:text-sm"
                    >
                      <i className="ri-arrow-right-s-line text-accent-300"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3 border-t border-accent-800 py-6 text-xs text-accent-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>本页为内容导览演示页，榜单与播放数据均为示例内容。</p>
          <p className="flex items-center gap-2">
            <i className="ri-refresh-line"></i>
            榜单每 30 分钟更新
          </p>
        </div>
      </div>
    </footer>
  );
}